import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { apiUrl } from '../../../config/apiConfig';
import './style.css';
import { useUser } from '../../../contexts/userContext';
import Header from '../../Header';
import api from '../../../services/api';

function Participantes() {
  const { user, empresa } = useUser();

  const [participantes, setParticipantes] = useState([]);
  const [selectedParticipante, setSelectedParticipante] = useState(null);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [citiesCobranca, setCitiesCobranca] = useState([]);
  const [citiesEntrega, setCitiesEntrega] = useState([]);
  const [cpfError, setCpfError] = useState('');
  const [formValues, setFormValues] = useState({
    name: '',
    email: '',
    telefone: '',
    endereco: '',
    tipo: 'Cliente',  // Tipo padrão definido como 'Cliente'
    state: '',
    city: '',
    cpf: '',
    // Dados do Faturamento
    nome_contato: '',
    email_nota_fiscal: '',
    email_nota_fiscal2: '',
    // Dados do Representante Legal
    representante_legal_nome: '',
    representante_legal_email: '',
    representante_legal_cpf: '',
    // Endereço de Cobrança
    endereco_cobranca_responsavel: '',
    endereco_cobranca_telefone: '',
    endereco_cobranca_email: '',
    endereco_cobranca_email2: '',
    endereco_cobranca_logradouro: '',
    endereco_cobranca_numero: '',
    endereco_cobranca_complemento: '',
    endereco_cobranca_bairro: '',
    endereco_cobranca_cidade: '',
    endereco_cobranca_uf: '',
    endereco_cobranca_cep: '',
    endereco_cobranca_condominio: '',
    // Endereço de Entrega
    endereco_entrega_logradouro: '',
    endereco_entrega_numero: '',
    endereco_entrega_complemento: '',
    endereco_entrega_bairro: '',
    endereco_entrega_cidade: '',
    endereco_entrega_uf: '',
    endereco_entrega_cep: '',
    endereco_entrega_condominio: '',
    // Gestores da Obra
    gestor_obra_nome: '',
    gestor_obra_telefone: '',
    gestor_obra_email: '',
    // Assinatura de Contrato
    email_assinatura_contrato: ''
  });
  const [showForm, setShowForm] = useState(false); // Estado para controlar a exibição do formulário

  useEffect(() => {
    if(empresa.id){
      fetchParticipantes();
      fetchStates();
    }
  }, [empresa]);

  useEffect(() => {
    if (formValues.state) {
      fetchCities(formValues.state);
    }
  }, [formValues.state]);

  useEffect(() => {
    if (formValues.endereco_cobranca_uf) {
      fetchCitiesCobranca(formValues.endereco_cobranca_uf);
    }
  }, [formValues.endereco_cobranca_uf]);

  useEffect(() => {
    if (formValues.endereco_entrega_uf) {
      fetchCitiesEntrega(formValues.endereco_entrega_uf);
    }
  }, [formValues.endereco_entrega_uf]);

  // const fetchParticipantes = async () => {
  //   try {
  //     const response = await axios.get(`${apiUrl}/card/participantes/${empresa.id}`);
  //     setParticipantes(response.data);
  //   } catch (error) {
  //     console.error('Erro ao buscar participantes:', error);
  //   }
  // };


  // const fetchParticipantes = async () => {
  //   try {
  //     const response = await axios.get(`${apiUrl}/card/participantes/by-entity/${user.id}`);
  //     setParticipantes(response.data);
  //   } catch (error) {
  //     console.error('Erro ao buscar participantes:', error);
  //   }
  // };
  const fetchParticipantes = async () => {
    try {
      const response = await api.get('/card/participantes/visible');
      setParticipantes(response.data);
    } catch (error) {
      console.error("Erro ao buscar participantes:", error);
    }
  };
  

  


  const fetchStates = async () => {
    try {
      const response = await axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome');
      setStates(response.data.map(state => ({ sigla: state.sigla, nome: state.nome })));
    } catch (error) {
      console.error('Erro ao buscar estados:', error);
    }
  };

  const fetchCities = async (state) => {
    try {
      const response = await axios.get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${state}/municipios?orderBy=nome`);
      setCities(response.data.map(city => ({ id: city.id, nome: city.nome })));
    } catch (error) {
      console.error('Erro ao buscar cidades:', error);
    }
  };

  const fetchCitiesCobranca = async (state) => {
    try {
      const response = await axios.get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${state}/municipios?orderBy=nome`);
      setCitiesCobranca(response.data.map(city => ({ id: city.id, nome: city.nome })));
    } catch (error) {
      console.error('Erro ao buscar cidades de cobrança:', error);
    }
  };

  const fetchCitiesEntrega = async (state) => {
    try {
      const response = await axios.get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${state}/municipios?orderBy=nome`);
      setCitiesEntrega(response.data.map(city => ({ id: city.id, nome: city.nome })));
    } catch (error) {
      console.error('Erro ao buscar cidades de entrega:', error);
    }
  };

  const validateCPF = (cpf) => {
    let sum = 0;
    let remainder;
    cpf = cpf.replace(/[^\d]+/g, ''); // Remove caracteres não numéricos

    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

    for (let i = 1; i <= 9; i++) sum += parseInt(cpf.substring(i - 1, i)) * (11 - i);
    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== parseInt(cpf.substring(9, 10))) return false;

    sum = 0;
    for (let i = 1; i <= 10; i++) sum += parseInt(cpf.substring(i - 1, i)) * (12 - i);
    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== parseInt(cpf.substring(10, 11))) return false;

    return true;
  };

  const validateCNPJ = (cnpj) => {
    cnpj = cnpj.replace(/[^\d]+/g, '');

    if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) return false;

    let size = cnpj.length - 2;
    let numbers = cnpj.substring(0, size);
    let digits = cnpj.substring(size);
    let sum = 0;
    let pos = size - 7;

    for (let i = size; i >= 1; i--) {
      sum += numbers.charAt(size - i) * pos--;
      if (pos < 2) pos = 9;
    }

    let result = sum % 11 < 2 ? 0 : 11 - sum % 11;
    if (result !== parseInt(digits.charAt(0))) return false;

    size = size + 1;
    numbers = cnpj.substring(0, size);
    sum = 0;
    pos = size - 7;

    for (let i = size; i >= 1; i--) {
      sum += numbers.charAt(size - i) * pos--;
      if (pos < 2) pos = 9;
    }

    result = sum % 11 < 2 ? 0 : 11 - sum % 11;
    if (result !== parseInt(digits.charAt(1))) return false;

    return true;
  };

  const validateDocument = (document) => {
    document = document.replace(/[^\d]+/g, '');
    if (document.length === 11) {
      return validateCPF(document);
    } else if (document.length === 14) {
      return validateCNPJ(document);
    }
    return false;
  };

  // const handleCreateParticipante = async () => {
  //   if (!formValues.cpf || !validateCPF(formValues.cpf)) {
  //     setCpfError('CPF inválido');
  //     return;
  //   }

  //   setCpfError('');

  //   const newParticipante = {
  //     ...formValues,
  //     empresa_id: empresa.id,
  //     entity_id: user.id,
  //   };

  //   try {
  //     await axios.post(`${apiUrl}/card/participantes/create`, newParticipante);
  //     alert('Participante criado com sucesso!');
  //     fetchParticipantes();
  //     resetForm();
  //   } catch (error) {
  //     console.error('Erro ao criar o participante:', error);
  //     alert('Erro ao criar o participante. Verifique o console para mais detalhes.');
  //   }
  // };

  const handleCreateParticipante = async () => {
    if (!formValues.cpf || !validateDocument(formValues.cpf)) {
      setCpfError("CPF/CNPJ inválido");
      return;
    }
  
    setCpfError("");
  
    const newParticipante = {
      ...formValues,
      empresa_id: empresa.id,
      entity_id: user.id,
    };
  
    try {
      await api.post("/card/participantes/create", newParticipante);
      alert("Participante criado com sucesso!");
      fetchParticipantes();
      resetForm();
    } catch (error) {
      console.error("Erro ao criar o participante:", error);
      const errorMessage = error.response?.data?.error || error.response?.data?.message || "Erro ao criar o participante. Verifique os dados e tente novamente.";
      alert(errorMessage);
    }
  };
  

  // const handleUpdateParticipante = async () => {
  //   if (!formValues.cpf || !validateCPF(formValues.cpf)) {
  //     setCpfError('CPF inválido');
  //     return;
  //   }

  //   setCpfError('');

  //   const updatedParticipante = {
  //     ...formValues,
  //     empresa_id: empresa.id,
  //     entity_id: user.id,
  //   };

  //   try {
  //     await axios.put(`${apiUrl}/card/participantes/update/${selectedParticipante.id}`, updatedParticipante);
  //     alert('Participante atualizado com sucesso!');
  //     fetchParticipantes();
  //     resetForm();
  //   } catch (error) {
  //     console.error('Erro ao atualizar o participante:', error);
  //     alert('Erro ao atualizar o participante. Verifique o console para mais detalhes.');
  //   }
  // };

  const handleUpdateParticipante = async () => {
    if (!formValues.cpf || !validateDocument(formValues.cpf)) {
      setCpfError("CPF/CNPJ inválido");
      return;
    }
  
    setCpfError("");
  
    const updatedParticipante = {
      ...formValues,
      empresa_id: empresa.id,
      entity_id: user.id,
    };
  
    try {
      await api.put(`/card/participantes/update/${selectedParticipante.id}`, updatedParticipante);
      alert("Participante atualizado com sucesso!");
      fetchParticipantes();
      resetForm();
    } catch (error) {
      console.error("Erro ao atualizar o participante:", error);
      const errorMessage = error.response?.data?.error || error.response?.data?.message || "Erro ao atualizar o participante. Verifique os dados e tente novamente.";
      alert(errorMessage);
    }
  };
  

  const resetForm = () => {
    setFormValues({
      name: '',
      email: '',
      telefone: '',
      endereco: '',
      tipo: 'Cliente',  // Resetando para o tipo padrão 'Cliente'
      state: '',
      city: '',
      cpf: '',
      // Dados do Faturamento
      nome_contato: '',
      email_nota_fiscal: '',
      email_nota_fiscal2: '',
      // Dados do Representante Legal
      representante_legal_nome: '',
      representante_legal_email: '',
      representante_legal_cpf: '',
      // Endereço de Cobrança
      endereco_cobranca_responsavel: '',
      endereco_cobranca_telefone: '',
      endereco_cobranca_email: '',
      endereco_cobranca_email2: '',
      endereco_cobranca_logradouro: '',
      endereco_cobranca_numero: '',
      endereco_cobranca_complemento: '',
      endereco_cobranca_bairro: '',
      endereco_cobranca_cidade: '',
      endereco_cobranca_uf: '',
      endereco_cobranca_cep: '',
      endereco_cobranca_condominio: '',
      // Endereço de Entrega
      endereco_entrega_logradouro: '',
      endereco_entrega_numero: '',
      endereco_entrega_complemento: '',
      endereco_entrega_bairro: '',
      endereco_entrega_cidade: '',
      endereco_entrega_uf: '',
      endereco_entrega_cep: '',
      endereco_entrega_condominio: '',
      // Gestores da Obra
      gestor_obra_nome: '',
      gestor_obra_telefone: '',
      gestor_obra_email: '',
      // Assinatura de Contrato
      email_assinatura_contrato: ''
    });
    setSelectedParticipante(null);
    setShowForm(false); // Esconde o formulário ao resetar
    setCitiesCobranca([]);
    setCitiesEntrega([]);
  };

  const handleEditParticipante = async (participante) => {
    setSelectedParticipante(participante);
    setFormValues(participante);
    setShowForm(true); // Mostra o formulário ao editar
    
    // Carrega as cidades se os estados estiverem preenchidos
    if (participante.endereco_cobranca_uf) {
      await fetchCitiesCobranca(participante.endereco_cobranca_uf);
    }
    if (participante.endereco_entrega_uf) {
      await fetchCitiesEntrega(participante.endereco_entrega_uf);
    }
  };

  // const handleDeleteParticipante = async (id) => {
  //   const userConfirmed = window.confirm(`Você tem certeza que deseja excluir este participante?`);
  //   if (!userConfirmed) return;

  //   try {
  //     await axios.delete(`${apiUrl}/card/participantes/delete/${id}`);
  //     alert('Participante excluído com sucesso!');
  //     fetchParticipantes();
  //     resetForm();
  //   } catch (error) {
  //     console.error('Erro ao excluir o participante:', error);
  //     alert('Erro ao excluir o participante. Verifique o console para mais detalhes.');
  //   }
  // };

  const handleDeleteParticipante = async (id) => {
    const userConfirmed = window.confirm("Você tem certeza que deseja excluir este participante?");
    if (!userConfirmed) return;
  
    try {
      await api.delete(`/card/participantes/delete/${id}`);
      alert("Participante excluído com sucesso!");
      fetchParticipantes();
      resetForm();
    } catch (error) {
      console.error("Erro ao excluir o participante:", error);
      alert("Erro ao excluir o participante. Verifique o console para mais detalhes.");
    }
  };
  

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedParticipante) {
      handleUpdateParticipante();
    } else {
      handleCreateParticipante();
    }
  };

  return (
    <div className="participantes-page-container">
      <Header />

      <div className="participantes-list-container">
        <h2>Lista de Participantes</h2>
        <button className="participantes-create-button" onClick={() => setShowForm(true)}>Criar Novo Participante</button>
        <ul>
          {participantes.map(participante => (
            <li key={participante.id} className="participantes-list-item">
              <span>{participante.name} - {participante.email}</span>
              <button className="participantes-edit-button" onClick={() => handleEditParticipante(participante)}>Editar</button>
            </li>
          ))}
        </ul>
      </div>

      {showForm && (
        <div className="participantes-modal-overlay">
          <div className="participantes-modal-content">
            <h2>{selectedParticipante ? 'Editar Participante' : 'Novo Participante'}</h2>
            <form onSubmit={handleSubmit}>
              <label>Nome:</label>
              <input
                type="text"
                value={formValues.name}
                onChange={(e) => setFormValues({ ...formValues, name: e.target.value })}
                className="participantes-input"
              />
              <label>Email:</label>
              <input
                type="email"
                value={formValues.email}
                onChange={(e) => setFormValues({ ...formValues, email: e.target.value })}
                className="participantes-input"
              />
              <label>Telefone:</label>
              <input
                type="text"
                value={formValues.telefone}
                onChange={(e) => setFormValues({ ...formValues, telefone: e.target.value })}
                className="participantes-input"
              />
              <label>Endereço:</label>
              <input
                type="text"
                value={formValues.endereco}
                onChange={(e) => setFormValues({ ...formValues, endereco: e.target.value })}
                className="participantes-input"
              />
              <label>Tipo de Participante:</label>
              <select
                value={formValues.tipo}
                onChange={(e) => setFormValues({ ...formValues, tipo: e.target.value })}
                className="participantes-select"
              >
                <option value="Cliente">Cliente</option>
                <option value="Arquiteto">Arquiteto</option>
                <option value="Construtora">Construtora</option>
                <option value="Construtor">Construtor</option>
                <option value="Fornecedor">Fornecedor</option>
                <option value="Parceiro">Parceiro</option>
                <option value="Colaborador">Colaborador</option>
                <option value="Investidor">Investidor</option>
                <option value="Outros">Outros</option>
              </select>
              <label>Estado:</label>
              <select
                value={formValues.state}
                onChange={(e) => setFormValues({ ...formValues, state: e.target.value })}
                className="participantes-select"
              >
                <option value="">Selecione o estado</option>
                {states.map(state => (
                  <option key={state.sigla} value={state.sigla}>{state.nome}</option>
                ))}
              </select>
              <label>Cidade:</label>
              <select
                value={formValues.city}
                onChange={(e) => setFormValues({ ...formValues, city: e.target.value })}
                className="participantes-select"
                disabled={!formValues.state}
              >
                <option value="">Selecione a cidade</option>
                {cities.map(city => (
                  <option key={city.id} value={city.nome}>{city.nome}</option>
                ))}
              </select>
              <label>CPF/CNPJ:</label>
              <input
                type="text"
                value={formValues.cpf}
                onChange={(e) => setFormValues({ ...formValues, cpf: e.target.value })}
                onBlur={() => validateDocument(formValues.cpf)}
                className="participantes-input"
                placeholder="Digite CPF ou CNPJ"
              />
              {cpfError && <div className="participantes-error-message">{cpfError}</div>}

              <h3 className="participantes-section-title">Dados do Faturamento</h3>
              <label>Nome para Contato:</label>
              <input
                type="text"
                value={formValues.nome_contato}
                onChange={(e) => setFormValues({ ...formValues, nome_contato: e.target.value })}
                className="participantes-input"
              />
              <label>Email para Nota Fiscal:</label>
              <input
                type="email"
                value={formValues.email_nota_fiscal}
                onChange={(e) => setFormValues({ ...formValues, email_nota_fiscal: e.target.value })}
                className="participantes-input"
              />
              <label>Email para Nota Fiscal - Opcional:</label>
              <input
                type="email"
                value={formValues.email_nota_fiscal2}
                onChange={(e) => setFormValues({ ...formValues, email_nota_fiscal2: e.target.value })}
                className="participantes-input"
              />

              <h3 className="participantes-section-title">Dados do Representante Legal</h3>
              <label>Nome:</label>
              <input
                type="text"
                value={formValues.representante_legal_nome}
                onChange={(e) => setFormValues({ ...formValues, representante_legal_nome: e.target.value })}
                className="participantes-input"
              />
              <label>Email:</label>
              <input
                type="email"
                value={formValues.representante_legal_email}
                onChange={(e) => setFormValues({ ...formValues, representante_legal_email: e.target.value })}
                className="participantes-input"
              />
              <label>CPF:</label>
              <input
                type="text"
                value={formValues.representante_legal_cpf}
                onChange={(e) => setFormValues({ ...formValues, representante_legal_cpf: e.target.value })}
                className="participantes-input"
                placeholder="Digite o CPF do representante legal"
              />

              <h3 className="participantes-section-title">Endereço de Cobrança</h3>
              <label>Responsável:</label>
              <input
                type="text"
                value={formValues.endereco_cobranca_responsavel}
                onChange={(e) => setFormValues({ ...formValues, endereco_cobranca_responsavel: e.target.value })}
                className="participantes-input"
              />
              <label>Telefone:</label>
              <input
                type="text"
                value={formValues.endereco_cobranca_telefone}
                onChange={(e) => setFormValues({ ...formValues, endereco_cobranca_telefone: e.target.value })}
                className="participantes-input"
              />
              <label>Email para Boleto:</label>
              <input
                type="email"
                value={formValues.endereco_cobranca_email}
                onChange={(e) => setFormValues({ ...formValues, endereco_cobranca_email: e.target.value })}
                className="participantes-input"
              />
              <label>Email para Boleto - Opcional:</label>
              <input
                type="email"
                value={formValues.endereco_cobranca_email2}
                onChange={(e) => setFormValues({ ...formValues, endereco_cobranca_email2: e.target.value })}
                className="participantes-input"
              />
              <label>Logradouro:</label>
              <input
                type="text"
                value={formValues.endereco_cobranca_logradouro}
                onChange={(e) => setFormValues({ ...formValues, endereco_cobranca_logradouro: e.target.value })}
                className="participantes-input"
              />
              <label>Número:</label>
              <input
                type="text"
                value={formValues.endereco_cobranca_numero}
                onChange={(e) => setFormValues({ ...formValues, endereco_cobranca_numero: e.target.value })}
                className="participantes-input"
              />
              <label>Complemento:</label>
              <input
                type="text"
                value={formValues.endereco_cobranca_complemento}
                onChange={(e) => setFormValues({ ...formValues, endereco_cobranca_complemento: e.target.value })}
                className="participantes-input"
              />
              <label>Bairro:</label>
              <input
                type="text"
                value={formValues.endereco_cobranca_bairro}
                onChange={(e) => setFormValues({ ...formValues, endereco_cobranca_bairro: e.target.value })}
                className="participantes-input"
              />
              <label>Estado:</label>
              <select
                value={formValues.endereco_cobranca_uf}
                onChange={(e) => setFormValues({ ...formValues, endereco_cobranca_uf: e.target.value })}
                className="participantes-select"
              >
                <option value="">Selecione o estado</option>
                {states.map(state => (
                  <option key={state.sigla} value={state.sigla}>{state.nome}</option>
                ))}
              </select>
              <label>Cidade:</label>
              <select
                value={formValues.endereco_cobranca_cidade}
                onChange={(e) => setFormValues({ ...formValues, endereco_cobranca_cidade: e.target.value })}
                className="participantes-select"
                disabled={!formValues.endereco_cobranca_uf}
              >
                <option value="">Selecione a cidade</option>
                {citiesCobranca.map(city => (
                  <option key={city.id} value={city.nome}>{city.nome}</option>
                ))}
              </select>
              <label>CEP:</label>
              <input
                type="text"
                value={formValues.endereco_cobranca_cep}
                onChange={(e) => setFormValues({ ...formValues, endereco_cobranca_cep: e.target.value })}
                className="participantes-input"
                placeholder="00000000"
              />
              <label>Endereço dentro do condomínio:</label>
              <input
                type="text"
                value={formValues.endereco_cobranca_condominio}
                onChange={(e) => setFormValues({ ...formValues, endereco_cobranca_condominio: e.target.value })}
                className="participantes-input"
              />

              <h3 className="participantes-section-title">Endereço de Entrega</h3>
              <label>Logradouro:</label>
              <input
                type="text"
                value={formValues.endereco_entrega_logradouro}
                onChange={(e) => setFormValues({ ...formValues, endereco_entrega_logradouro: e.target.value })}
                className="participantes-input"
              />
              <label>Número:</label>
              <input
                type="text"
                value={formValues.endereco_entrega_numero}
                onChange={(e) => setFormValues({ ...formValues, endereco_entrega_numero: e.target.value })}
                className="participantes-input"
              />
              <label>Complemento:</label>
              <input
                type="text"
                value={formValues.endereco_entrega_complemento}
                onChange={(e) => setFormValues({ ...formValues, endereco_entrega_complemento: e.target.value })}
                className="participantes-input"
              />
              <label>Bairro:</label>
              <input
                type="text"
                value={formValues.endereco_entrega_bairro}
                onChange={(e) => setFormValues({ ...formValues, endereco_entrega_bairro: e.target.value })}
                className="participantes-input"
              />
              <label>Estado:</label>
              <select
                value={formValues.endereco_entrega_uf}
                onChange={(e) => setFormValues({ ...formValues, endereco_entrega_uf: e.target.value })}
                className="participantes-select"
              >
                <option value="">Selecione o estado</option>
                {states.map(state => (
                  <option key={state.sigla} value={state.sigla}>{state.nome}</option>
                ))}
              </select>
              <label>Cidade:</label>
              <select
                value={formValues.endereco_entrega_cidade}
                onChange={(e) => setFormValues({ ...formValues, endereco_entrega_cidade: e.target.value })}
                className="participantes-select"
                disabled={!formValues.endereco_entrega_uf}
              >
                <option value="">Selecione a cidade</option>
                {citiesEntrega.map(city => (
                  <option key={city.id} value={city.nome}>{city.nome}</option>
                ))}
              </select>
              <label>CEP:</label>
              <input
                type="text"
                value={formValues.endereco_entrega_cep}
                onChange={(e) => setFormValues({ ...formValues, endereco_entrega_cep: e.target.value })}
                className="participantes-input"
                placeholder="00000000"
              />
              <label>Endereço dentro do condomínio:</label>
              <input
                type="text"
                value={formValues.endereco_entrega_condominio}
                onChange={(e) => setFormValues({ ...formValues, endereco_entrega_condominio: e.target.value })}
                className="participantes-input"
              />

              <h3 className="participantes-section-title">Gestores da Obra</h3>
              <label>Nome:</label>
              <input
                type="text"
                value={formValues.gestor_obra_nome}
                onChange={(e) => setFormValues({ ...formValues, gestor_obra_nome: e.target.value })}
                className="participantes-input"
              />
              <label>Telefone:</label>
              <input
                type="text"
                value={formValues.gestor_obra_telefone}
                onChange={(e) => setFormValues({ ...formValues, gestor_obra_telefone: e.target.value })}
                className="participantes-input"
              />
              <label>Email:</label>
              <input
                type="email"
                value={formValues.gestor_obra_email}
                onChange={(e) => setFormValues({ ...formValues, gestor_obra_email: e.target.value })}
                className="participantes-input"
              />

              <h3 className="participantes-section-title">Assinatura de Contrato</h3>
              <label>Email para Assinatura de Contrato:</label>
              <input
                type="email"
                value={formValues.email_assinatura_contrato}
                onChange={(e) => setFormValues({ ...formValues, email_assinatura_contrato: e.target.value })}
                className="participantes-input"
              />

              <div className="participantes-form-buttons">

                <button type="button" className="participantes-cancel-button" onClick={resetForm}>Cancelar</button>
                {selectedParticipante && (
                  <button type="button" className="participantes-delete-button" onClick={() => handleDeleteParticipante(selectedParticipante.id)}>Excluir</button>
                )}
                <button type="submit" className="participantes-submit-button">{selectedParticipante ? 'Atualizar' : 'Criar'}</button>


              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Participantes;
